import React from 'react';
import QRCode from 'react-qr-code';
import styled from 'styled-components';
import { CustomerVerificationViewProps } from './models';
import blueShield from '../../assets/shield.svg';
import { TitleV2 as Title, OnlineButton as Button } from '@sunbit-dev/web-ui-lib';
import { useTranslation } from '@sunbit-dev/translations';
import * as styles from './styles';
import { CustomerSendVerificationPopup } from '../customerSendVerificationPopup/CustomerSendVerificationPopup';

export const CustomerVerificationView = styled(
  ({
    className,
    verificationLink,
    onSendSmsClick,
    phoneNumber,
    isSmsPopupOpen,
    onCloseSmsPopup,
  }: CustomerVerificationViewProps) => {
    const { t } = useTranslation('components', { keyPrefix: 'customer_verification_view' });

    return (
      <div className={className}>
        <div className={'header-icon'}>
          <img src={blueShield} />
        </div>
        <Title className="title">{t('title')}</Title>
        <p className="description">{t('description')}</p>
        <Button
          {...{
            disabled: isSmsPopupOpen,
            className: 'submit-button',
            submit: onSendSmsClick,
            dataTestId: 'checkout-pay-button',
            buttonText: t('button'),
          }}
        />
        {isSmsPopupOpen && (
          <CustomerSendVerificationPopup
            {...{ onClose: onCloseSmsPopup, resendCallback: onSendSmsClick, phoneNumber }}
            noLightBox
          />
        )}
        <div className={'qr-container'}>
          <QRCode level={'M'} size={107} value={verificationLink} />
        </div>
      </div>
    );
  }
)`
  ${styles.CustomerVerificationView}
`;
